























import { Component, Vue, Prop } from 'vue-property-decorator'
import { AddSensor, SensorType } from '../store/sensor'

@Component
export default class SensorForm extends Vue {
  @Prop() title!: string
  @Prop({ default: () => ({}) }) placeholder!: AddSensor
  name = this.placeholder.name || ''
  scale = this.placeholder.scale || 1
  unit = this.placeholder.unit || ''
  type = this.placeholder.type || ''
  get types() {
    return [SensorType.DIGITAL, SensorType.ANALOG]
  }
  nameRules = [(v: string) => !!v || 'Name is required']
  typeRules = [(v: string) => !!v || 'Type is required']
  scaleRules = [(v: string) => !!v || 'Scale is required']

  valid = false

  submit() {
    this.$emit('submit', {
      name: this.name,
      scale: this.scale,
      unit: this.unit,
      type: this.type
    })
  }
  cancel() {
    this.$emit('cancel')
  }
}
